import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "./style.css";

import { Navigation, Autoplay } from "swiper/modules";
import { Box, IconButton, Typography } from "@mui/material";
import { SliderArrowLeft, SliderArrowRight } from "../../assets/icons/MUI/LoginIcons";
import SirAlex from "../../assets/images/Login/SirAlex.png";
import Pele from "../../assets/images/Login/Pele.png";
import Beckenbauer from "../../assets/images/Login/Beckenbauer.png";
import { useTranslation } from "react-i18next";

const QuotesSlider = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        maxWidth: "650px",
        margin: "0 auto",
      }}
    >
      <Swiper
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Navigation, Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "25px" }}>
            <Box
              component="figure"
              sx={{
                display: "flex",
                columnGap: "20px",
                alignItems: "center",
                justifyContent: "flex-start",
                margin: "0",
              }}
            >
              <img src={SirAlex} width="51px" height="51px" />
              <Typography
                component="figcaption"
                sx={{
                  color: "var(--White, #FFF)",
                  fontFamily: "HeadingNowVarTrial",
                  fontSize: "40px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "45px",
                  letterSpacing: "-0.8px",
                }}
              >
                {t("pages.login.sirAlex")}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "45px",
                letterSpacing: "-0.6px",
              }}
            >
              “{t("pages.login.sirAlexQuote")}”
            </Typography>
          </Box>
        </SwiperSlide>
        <SwiperSlide>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "25px" }}>
            <Box
              component="figure"
              sx={{
                display: "flex",
                columnGap: "20px",
                alignItems: "center",
                justifyContent: "flex-start",
                margin: "0",
              }}
            >
              <img src={Beckenbauer} width="51px" height="51px" />
              <Typography
                component="figcaption"
                sx={{
                  color: "var(--White, #FFF)",
                  fontFamily: "HeadingNowVarTrial",
                  fontSize: "40px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "45px",
                  letterSpacing: "-0.8px",
                }}
              >
                {t("pages.login.beckenbauer")}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "45px",
                letterSpacing: "-0.6px",
              }}
            >
              “{t("pages.login.beckenbauerQoute")}”
            </Typography>
          </Box>
        </SwiperSlide>
        <SwiperSlide>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "25px" }}>
            <Box
              component="figure"
              sx={{
                display: "flex",
                columnGap: "20px",
                alignItems: "center",
                justifyContent: "flex-start",
                margin: "0",
              }}
            >
              <img src={Pele} width="51px" height="51px" />
              <Typography
                component="figcaption"
                sx={{
                  color: "var(--White, #FFF)",
                  fontFamily: "HeadingNowVarTrial",
                  fontSize: "40px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "45px",
                  letterSpacing: "-0.8px",
                }}
              >
                {t("pages.login.pele")}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "45px",
                letterSpacing: "-0.6px",
              }}
            >
              “{t("pages.login.peleQuote")}”
            </Typography>
          </Box>
        </SwiperSlide>
        <SliderNavigation />
      </Swiper>
    </Box>
  );
};

export default QuotesSlider;

const SliderNavigation = () => {
  const swiper = useSwiper();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <Box
      sx={{
        display: "flex",
        columnGap: "32px",
        marginTop: "167px",
      }}
    >
      <IconButton
        onClick={() => swiper.slidePrev()}
        sx={{
          border: "1px solid rgba(255, 255, 255, 0.50)",
          backdropFilter: " blur(4px)",
        }}
      >
        {currentLang === "en" ? <SliderArrowLeft /> : <SliderArrowRight />}
      </IconButton>
      <IconButton
        onClick={() => swiper.slideNext()}
        sx={{
          border: "1px solid rgba(255, 255, 255, 0.50)",
          backdropFilter: " blur(4px)",
        }}
      >
        {currentLang === "en" ? <SliderArrowRight /> : <SliderArrowLeft />}
      </IconButton>
    </Box>
  );
};

// const SlideQuote = ({ img, name, description }: { img: string; name: string; description: string }) => (
//   <SwiperSlide>
//     <Box sx={{ display: "flex", flexDirection: "column", gap: "25px" }}>
//       <Box
//         component="figure"
//         sx={{
//           display: "flex",
//           columnGap: "20px",
//           alignItems: "center",
//           justifyContent: "flex-start",
//           margin: "0",
//         }}
//       >
//         <img src={img} width="51px" height="51px" />
//         <Typography
//           component="figcaption"
//           sx={{
//             color: "var(--White, #FFF)",
//             fontFamily: "HeadingNowVarTrial",
//             fontSize: "40px",
//             fontStyle: "normal",
//             fontWeight: 600,
//             lineHeight: "45px",
//             letterSpacing: "-0.8px",
//           }}
//         >
//           {name}
//         </Typography>
//       </Box>
//       <Typography
//         sx={{
//           color: "var(--White, #FFF)",
//           fontFamily: "Montserrat",
//           fontSize: "30px",
//           fontStyle: "normal",
//           fontWeight: 500,
//           lineHeight: "45px",
//           letterSpacing: "-0.6px",
//         }}
//       >
//         “{description}”
//       </Typography>
//     </Box>
//   </SwiperSlide>
// );
